import { APIValidationError } from '../../types/api/api';
import { UUID } from '../../types/standard';
import { Result, validatedApiCall } from '../api';
import { AlertsDTO } from './getAlerts';

export const deleteAlerts = async (
  data: UUID[],
): Promise<Result<AlertsDTO, APIValidationError>> =>
  validatedApiCall<AlertsDTO>(`/api/alertas/delete`, {
    method: 'DELETE',
    auth: true,
    body: JSON.stringify({ alerta_ids: data }),
  });
